module.exports = __webpack_public_path__ + "static/header-a9f43f9840e46a9cf9c4ea52ab9b0837.png";